import { useCallback } from 'preact/hooks';

import { isTapEvent } from '../utils/events';

import { useDoubleClick } from './useDoubleClick';

export const useDoubleTap = ({
  onTap,
  onDoubleTap,
}: {
  onTap: (e: MouseEvent) => void;
  onDoubleTap: () => void;
}) => {
  const { handleClick: handleTap } = useDoubleClick({
    onClick: onTap,
    onDoubleClick: onDoubleTap,
  });

  const handleClick = useCallback(
    (e: MouseEvent) => {
      if (!isTapEvent(e)) {
        return;
      }

      handleTap(e);
    },
    [handleTap]
  );

  return { handleClick };
};
